module.exports = __webpack_public_path__ + "static/media/aboutshape.d6a094e2.webp";